{
  "title": "Blade Barrier",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level evocation",
  "level": 6,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You create a vertical wall of whirling, razor-sharp blades made of magical energy. The wall appears within range and lasts for the duration. You can make a straight wall up to 100 feet long, 20 feet high, and 5 feet thick, or a ringed wall up to 60 feet in diameter, 20 feet high, and 5 feet thick. The wall provides three-quarters cover to creatures behind it, and its space is difficult terrain.",
    "When a creature enters the wall’s area for the first time on a turn or starts its turn there, the creature must make a Dexterity saving throw. On a failed save, the creature takes 6d10 slashing damage. On a successful save, the creature takes half as much damage."
  ],
  "spellLists": ["cleric"]
}
